import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const AppleIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "AppleIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.2417 6.61538C13.1444 6.61538 14.276 6.00509 14.9499 5.19135C15.5602 4.45391 16.0052 3.42403 16.0052 2.39415C16.0052 2.25429 15.9925 2.11443 15.9671 2C14.9626 2.03814 13.7547 2.67387 13.03 3.52575C12.4578 4.17419 11.9365 5.19135 11.9365 6.23395C11.9365 6.38652 11.962 6.5391 11.9747 6.58996C12.0383 6.60267 12.14 6.61538 12.2417 6.61538ZM9.06305 22C10.2964 22 10.8431 21.1736 12.3815 21.1736C13.9454 21.1736 14.2887 21.9746 15.6619 21.9746C17.0096 21.9746 17.9124 20.7285 18.7643 19.5079C19.7178 18.1093 20.112 16.7362 20.1374 16.6726C20.0484 16.6472 17.4674 15.5919 17.4674 12.6294C17.4674 10.061 19.5017 8.90401 19.6161 8.815C18.2684 6.88239 16.2213 6.83153 15.6619 6.83153C14.1489 6.83153 12.9156 7.74698 12.14 7.74698C11.3008 7.74698 10.1946 6.88239 8.88504 6.88239C6.39299 6.88239 3.86279 8.94215 3.86279 12.8328C3.86279 15.2486 4.80367 17.8042 5.96069 19.4571C6.95243 20.8557 7.81702 22 9.06305 22Z"
        fill="black"
      />
    </svg>
  );
};

export default AppleIcon;
